<template>
    <section class="interview-title light orange">
        <div class="css-grid">
            <div class="bg" style="background-image: url(/static/img/pages/interview-la-rose.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light orange">
                    <h3>Interview La&nbsp;Rose&nbsp;Kifu</h3>
                    <h2>Waarom &eacute;&eacute;n ding worden als je zoveel kunt zijn?</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped></style>

<script>
    import InterviewLaRose from '@/app/pages/sub/InterviewLaRose';

    export default {
        name: 'CarriereInterview',
        meta: {
            title: 'CarriereInterview',
            color: '#FE5D0B'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewLaRose );
            }
        }
    };
</script>
